module.exports = __webpack_public_path__ + "static/media/pathways.af8ad1b6.jpg";